import {
  messageHandlers,
  setupInitialMessage,
  setupPageTitle,
  setupLocale,
} from './santa-handlers';

function generateResponseFunction(event, msg) {
  return function (data, intent = 'TPA_RESPONSE') {
    return event.source.postMessage(
      JSON.stringify({
        intent,
        callId: msg.callId,
        type: msg.type,
        res: data,
        ...data,
        status: true,
      }),
      '*',
    );
  };
}

function executeHandler(event) {
  try {
    const payload = JSON.parse(event.data);

    const eventName = payload.type;
    if (messageHandlers[eventName]) {
      const params = payload.data;
      messageHandlers[eventName](
        params,
        generateResponseFunction(event, payload),
      );
    }
  } catch (e) {}
}

export const initSantaHandlers = ({ initialMessage, pageTitle, locale }) => {
  setupInitialMessage(initialMessage);
  setupLocale(locale);
  setupPageTitle(pageTitle);
  window.addEventListener('message', executeHandler);
};
